import React from "react";
import FacebookIcon from '@material-ui/icons/Facebook';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import InstagramIcon from '@material-ui/icons/Instagram';

const Footer = ({ data }) => {
  if (data) {
    var networks = data.social.map(function (network) {
      return (
        <li key={network.name}>
          <a href={network.url}>
            <i className={network.className}></i>
          </a>
        </li>
      );
    });
  }

  return (
    <footer>
      <div className="row">
        <div className="twelve columns">
          <ul className="social">
              <a href='https://www.facebook.com/profile.php?id=100068240016612' target='_blank' ><FacebookIcon className='social-icons' /></a>
              <a href='https://github.com/Arjun-Joshi20' target='_blank' ><GitHubIcon className='social-icons' /></a>
              <a href='https://www.linkedin.com/in/arjun-joshi-4581b0219/' target='_blank' ><LinkedInIcon className='social-icons' /></a>
              <a href='https://www.instagram.com/arjun.jsx/' target='_blank' ><InstagramIcon className='social-icons' /></a>
            </ul>

          <ul className="copyright">
            <li>
              Made by{" "}
              <a title="PAPA" href="http://www.papareact.com/">
               Arjun Joshi
              </a>
            </li>
          </ul>
        </div>
        <div id="go-top">
          <a className="smoothscroll" title="Back to Top" href="#home">
            <i className="icon-up-open"></i>
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
